import React from "react";
import { Box, Button, Icon, Text } from "@chakra-ui/react";
import {
  MdOutlineBolt,
  MdOutlinePhoneIphone,
  MdOutlineTv,
  MdOutlineWifi,
  MdArrowCircleUp,
  MdArrowUpward,
  MdOutlineDirectionsCar,
  MdOutlineSchool,
} from "react-icons/md";

export const VTU_FEATURE_MOCK_DATA = [
  {
    key: "data",
    title: "Data",
    description: "Purchase internet bundles for all supported networks.",
    icon: MdOutlineWifi,
  },
  {
    key: "electricity",
    title: "Electricity",
    description: "Pay electricity bills quickly and keep your meter active.",
    icon: MdOutlineBolt,
  },
  {
    key: "airtime",
    title: "Airtime",
    description: "Top up airtime instantly for any mobile network.",
    icon: MdOutlinePhoneIphone,
  },
  {
    key: "cable",
    title: "Cable",
    description: "Renew cable TV subscriptions without leaving your dashboard.",
    icon: MdOutlineTv,
  },
  {
    key: "insurance",
    title: "Insurance",
    description: "Purchase motor vehicle insurance quickly and securely.",
    icon: MdOutlineDirectionsCar,
  },
  {
    key: "education",
    title: "Education",
    description: "Purchase WAEC, JAMB and other education PINs instantly.",
    icon: MdOutlineSchool,
  },
];

const VTUFeatureCard = ({ title, description, icon, onClick, isDisabled }) => {
  return (
    <Box
      _hover={
        isDisabled
          ? undefined
          : { transform: "scale(1.05)", transition: "transform 0.2s ease" }
      }
      position="relative"
      bg={isDisabled ? "gray.400" : "primary.500"}
      opacity={isDisabled ? 0.7 : 1}
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius="10px"
      boxShadow="sm"
      p="14px"
      minH="130px"
      title={isDisabled ? "Currently unavailable" : undefined}
    >
      <Button
        size="lg"
        onClick={onClick}
        isDisabled={isDisabled}
        aria-label={isDisabled ? `${title} currently unavailable` : `Pay ${title}`}
        position="absolute"
        top="10px"
        right="10px"
        minW="32px"
        h="32px"
        p="0"
        backdropBlur={"base"}
        borderRadius="full"
        bg="#ffffff11"
        border="1px solid white"
        color="white"
        cursor={isDisabled ? "not-allowed" : "pointer"}
        transform="scale(1)"
        transition="transform 0.2s ease, background-color 0.2s ease"
        _hover={isDisabled ? undefined : { bg: "primary.100", transform: "scale(1.3)" }}
      >
        <Icon
          sx={{
            transform: "rotate(45deg)",
          }}
          as={MdArrowUpward}
          boxSize="16px"
        />
      </Button>

      <Box
        sx={{
          display: "flex",
          gap: "1em",
          height: "100%",
          alignItems: "center",
        }}
      >
        <Box
          w="38px"
          h="38px"
          borderRadius="8px"
          bg="white"
          color="primary.500"
          display="flex"
          p={"1em"}
          alignItems="center"
          justifyContent="center"
          mb="10px"
        >
          <Icon as={icon} color={"primary.500"} boxSize="20px" />
        </Box>
        <Box
          sx={{
            d: "flex",
            flexDirection: "column",
          }}
        >
          <Text as={"span"} w="100%" fontWeight="700" color="white" mb="4px">
            {title}
          </Text>
          <Text as={"span"} w="100%" fontSize="14px" color="white">
            {isDisabled ? "Currently unavailable" : "Bills"}
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default VTUFeatureCard;
